(function () {

  const handleView = () => {
    $(".info-bar-main").each(function () {
      const $section = $(this);
      const isMobile = window.innerWidth < 768;

      const $swiper = $section.find(".swiper");
      const $desktop = $section.find(".desktop-only");

      if (isMobile) {
        $swiper.show();
        $desktop.hide();
      } else {
        $swiper.hide();
        $desktop.show();
      }
    });
  };

  const tickSlider = () => {
    $(".ticker").each(function () {

      const $this = $(this);
      const isMobile = window.innerWidth < 768;

      if (!isMobile) return;

      if ($this.hasClass('slider_started')) {
        return;
      }

      $this.addClass('slider_started');

      const tickerId = $this.data('ticker-id');
      const tickerSpeed = $this.data('ticker-speed') * 1000;

      new Swiper(`.ticker-js-${tickerId}`, {
        slidesPerView: "auto",
        speed: tickerSpeed,
        initialSlide: 0,
        loop: true,
        loopedSlides: 50,
        allowTouchMove: false,
        waitForTransition: false,
        watchSlidesProgress: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
        },
      });

    });
  };

  const destroySwiper = () => {
    $(".ticker").each(function () {
      const $this = $(this);
      const swiperEl = $this.find(".swiper")[0];

      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.destroy(true, true);
        $this.removeClass('slider_started');
      }
    });
  };

  const init = () => {
    handleView();

    if (window.innerWidth <= 768) {
      tickSlider();
    } else {
      destroySwiper();
    }
  };

  // Initial load
  document.addEventListener("DOMContentLoaded", init);

  // Resize 🔥
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      init();
    }, 200);
  });

  // Shopify section reload
  document.addEventListener("shopify:section:load", function () {
    setTimeout(() => {
      init();
    }, 100);
  });

  // Tab switch fix
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) {
      init();
    }
  });

})();